<script setup>
import SInfoMontant from '@/components/global/s-info-montant.vue'
</script>

<template>
  <v-chip class="ml-2 my-1" color="primary" outlined>
    <v-icon left small>{{ icone }}</v-icon>
    <s-info-montant :montant="ligne.montant" />
  </v-chip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    ligne: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      iconFromPoste: 'posteAIM/getIconePourPosteAimId',
    }),
    icone() {
      return this.iconFromPoste(this.ligne.posteAIM)
    },
  },
}
</script>

<style scoped></style>
